export default function Slide({ slide, isActive, categoriesBanner }) {
  return (
    <div
      className={`absolute inset-0 transition-opacity duration-500 ease-in-out text-white ${
        isActive ? 'opacity-100 z-10' : 'opacity-0 z-0'
      }`}
    >
      {slide.image ? (
        <>
          <div className="hidden md:block h-full">
            <img
              src={slide.image}
              alt="Slide image"
              className={`w-full h-full object-cover ${categoriesBanner !== false ? 'rounded-[10px]' : ''}`}
            />
          </div>
          <div className="md:hidden h-full">
            <img
              src={slide.imageMobile}
              alt="Slide image"
              className="w-full h-full object-cover"
            />
          </div>
        </>
      ) : (
        <div
          className="w-full h-full flex items-center justify-center"
          style={{ backgroundColor: '#0D1BFF' }}
        >
          <p className="text-white">Image not available</p>
        </div>
      )}
      {/* <div className="absolute inset-0 bg-black/40 rounded-xl" /> */}
      <div className="absolute   inset-0  md:inset-24 p-3  md:text-justify md:flex hidden flex-col">
        {slide.content}
      </div>
    </div>
  );
}
